import { render, staticRenderFns } from "./sendSMSEst.vue?vue&type=template&id=9571a830&scoped=true"
import script from "./sendSMSEst.vue?vue&type=script&lang=js"
export * from "./sendSMSEst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9571a830",
  null
  
)

export default component.exports